// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__D+YZl","icon":"IconButton_icon__dANSL"};